import { render, staticRenderFns } from "./AskueConsumptionTable.component.vue?vue&type=template&id=3bacf807&"
import script from "./AskueConsumptionTable.component.vue?vue&type=script&lang=ts&"
export * from "./AskueConsumptionTable.component.vue?vue&type=script&lang=ts&"
import style0 from "./AskueConsumptionTable.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports